import CloseRounded from '@mui/icons-material/CloseRounded';
import {
  Box,
  IconButton,
  Paper,
  Stack,
  Typography,
  styled,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import { pxToRem } from '~/theme/typography';

export const resourceLatestNews = {
  PageRoot: styled(Box)(() => ({
    width: '100%',
    maxWidth: 1192,
    alignSelf: 'stretch',
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingBottom: 32,
  })),

  EmptyPaper: styled(Paper)(({ theme }) => ({
    padding: theme.spacing(4),
    textAlign: 'center',
    borderRadius: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
  })),

  EmptyText: styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
    fontSize: pxToRem(16),
  })),

  ListStack: styled(Stack)(({ theme }) => ({
    gap: theme.spacing(2.5),
  })),

  PaginationStack: styled(Stack)(({ theme }) => ({
    alignItems: 'center',
    marginTop: theme.spacing(3),
  })),

  LightboxPaperSx: {
    m: 0,
    maxWidth: 'none',
    maxHeight: 'none',
    width: '100%',
    height: '100%',
    bgcolor: 'transparent',
    boxShadow: 'none',
    overflow: 'hidden',
  } as const,

  LightboxBackdropSx: {
    backgroundColor: alpha('#000000', 0.72),
  } as const,

  LightboxStage: styled(Box)(({ theme }) => ({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    /** 以 dvh 對齊實際可視高度，避免 1280×800 等小螢幕被 100vh + padding 擠出裁切 */
    minHeight: '100dvh',
    height: '100dvh',
    maxHeight: '100dvh',
    width: '100%',
    maxWidth: '100vw',
    boxSizing: 'border-box',
    overflow: 'hidden',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  })),

  LightboxClose: styled(IconButton)(({ theme }) => ({
    position: 'fixed',
    top: theme.spacing(2),
    right: theme.spacing(2),
    zIndex: theme.zIndex.modal + 1,
    color: theme.palette.common.white,
    backgroundColor: alpha(theme.palette.common.black, 0.35),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.black, 0.5),
    },
  })),

  LightboxImage: styled('img')(({ theme }) => ({
    maxWidth: 'min(92vw, 1200px)',
    maxHeight: '88vh',
    width: 'auto',
    height: 'auto',
    objectFit: 'contain',
    borderRadius: theme.spacing(1),
    display: 'block',
  })),

  /**
   * 放大播放：寬度同時受視窗寬、高限制，小筆電（如 1280×800）不會因 16:9 過高而被裁切。
   */
  LightboxVideoOuter: styled(Box)(() => ({
    boxSizing: 'border-box',
    width: 'min(1200px, calc(100vw - 48px), calc((100dvh - 96px) * 16 / 9))',
    maxWidth: '100%',
    flex: '0 1 auto',
    alignSelf: 'center',
    minWidth: 0,
    marginLeft: 'auto',
    marginRight: 'auto',
  })),

  LightboxVideoInner: styled(Box)(({ theme }) => ({
    position: 'relative',
    boxSizing: 'border-box',
    width: '100%',
    aspectRatio: '16 / 9',
    maxHeight: 'calc(100dvh - 96px)',
    borderRadius: theme.spacing(1),
    overflow: 'hidden',
    border: `2px solid ${theme.palette.common.black}`,
    backgroundColor: theme.palette.grey[900],
    contain: 'layout paint',
  })),

  LightboxIframe: styled('iframe')(() => ({
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    maxWidth: '100%',
    maxHeight: '100%',
    border: 0,
  })),
};

export const ResourceLatestNewsIcons = {
  Close: CloseRounded,
};
